import { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { Button, Input } from '@/design-system';

export function SecretSettingsInput({ label, value, onChange, placeholder }: {
  label: string; value: string; onChange: (value: string) => void; placeholder?: string;
}) {
  const [show, setShow] = useState(false);
  const masked = value === '••••••••••';
  return <div>
    <div className="relative">
      <Input label={label} type={show && !masked ? 'text' : 'password'} value={value} placeholder={placeholder}
        onChange={(event) => onChange(event.target.value)} className="pr-10" />
      <Button variant="ghost" size="sm" className="absolute bottom-0.5 right-1 px-1" aria-label={show ? `Ocultar ${label}` : `Mostrar ${label}`}
        onClick={() => setShow(!show)}>{show ? <EyeOff size={16} /> : <Eye size={16} />}</Button>
    </div>
    {masked && <p className="mt-1 text-xs text-gray-500">Chave configurada. Informe um novo valor para substituí-la.</p>}
  </div>;
}
